<template>
  <div>
    <div v-if="mode === 'DESIGN'" class="disabled-box max-width" >
      <el-button size="mini" class="btn-upload" icon="iconfont el-icon-plus" >选择人员</el-button>
    </div>
    <div v-else>

      <div v-if="!readerMode  || perm==='E'" class="max-width"  :class="{'no-focus': hiddenError}" >
        <!-- {{ hiddenError }} -->
        <el-select v-model="_value" @click.native="selectUser" @remove-tag="removeTag" value-key="name" :disabled="perm==='R'"
                  class="select-u" placeholder="选择人员"
                  size="small" multiple popper-class="hidden">
          <el-option v-for="(wc, index) in _value" :label="wc.serial + wc.name" :key="index" :value="wc"></el-option>
        </el-select>
        <org-picker title="选择人员" :multiple="true" ref="orgPicker" :selected="_value" @ok="selected"  @cancel="cancel"/>
      </div>
      <div v-else class="form-item-text">
        {{ valueText }}
      </div>

    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'
import OrgPicker from "@/components/OrgPicker";

export default {
  mixins: [componentMinxins],
  name: "UserPicker",
  components: {OrgPicker},
  props: {
    value:{
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择人员'
    },
    multiple:{
      type: Boolean,
      default: false
    },
    readerMode: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    valueText() {
      return this.value.map(item => item.serial + item.name).join('、')
    }
  },
  data() {
    return {
      showOrgSelect: false,
      hiddenError:false
    }
  },
  methods: {
    cancel(){
      this.hiddenError = false
      this.$parent.hiddenError = false
    },
    selected(values){
      this.hiddenError = false
      this.$parent.hiddenError = false
      this.showOrgSelect = false
      this._value = values
    },
    delDept(i){
      this._value.splice(i, 1)
    },
    selectUser() {
      this.hiddenError = true
      this.$parent.hiddenError = true
      this.$refs.orgPicker.show( this._value,'user')
    },
    removeTag(item){
    }
  }
}
</script>

<style lang="scss" scoped>
.max-width{
  max-width: 100%;
}
.btn-upload{
  width: 108px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #E3E6E5;
  padding:0;
  display:flex;
  align-items:center;
  justify-content:center;
  /deep/ span{
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:14px;
    font-weight:normal;
    color:#2F3030;
    &:hover{
      color:#2F3030;
    }
  }
}
.placeholder{
  // margin-left: 10px;
  color: #adabab;
  font-size: 13px;
}
.select-u{
        width: 100%;
        // max-width: 472px;
      }
</style>
